import post01 from './01-살모사-죽이는-꿈-로또번호-및-꿈해몽.json';
import post02 from './02-살모사-죽는-꿈-로또번호-및-꿈해몽.json';
import post03 from './03-살모사-키우는-꿈-로또번호-및-꿈해몽.json';
import post04 from './04-살모사-먹이-주는-꿈-로또번호-및-꿈해몽.json';
import post05 from './05-살모사-도망가는-꿈-로또번호-및-꿈해몽.json';
import post06 from './06-살모사-집에-들어오는-꿈-로또번호-및-꿈해몽.json';
import post07 from './07-살모사-품에-안는-꿈-로또번호-및-꿈해몽.json';
import post08 from './08-살모사-새끼-낳는-꿈-로또번호-및-꿈해몽.json';
import post09 from './09-살모사-많이-나오는-꿈-로또번호-및-꿈해몽.json';
import post10 from './10-큰-살모사-꿈해몽-로또번호-및-해석.json';
import post11 from './11-작은-살모사-꿈해몽-로또번호-및-해석.json';
import post12 from './12-새끼-살모사-꿈해몽-로또번호-및-해석.json';
import post13 from './13-죽은-살모사-꿈해몽-로또번호-및-해석.json';
import post14 from './14-하얀-살모사-꿈해몽-로또번호-및-해석.json';
import post15 from './15-검은-살모사-꿈해몽-로또번호-및-해석.json';
import post16 from './16-살모사-태몽-로또번호-및-꿈해몽.json';
import post17 from './17-살모사-로또-꿈-번호와-꿈해몽.json';
import post18 from './18-살모사-공격하는-꿈-로또번호-및-꿈해몽.json';
import post19 from './19-살모사와-노는-꿈-로또번호-및-꿈해몽.json';
import post20 from './20-용-잡는-꿈-로또번호-및-꿈해몽.json';
import post21 from './21-용에게-물리는-꿈-로또번호-및-꿈해몽.json';
import post22 from './22-용한테-쫓기는-꿈-로또번호-및-꿈해몽.json';
import post23 from './23-용-죽이는-꿈-로또번호-및-꿈해몽.json';
import post24 from './24-용-죽는-꿈-로또번호-및-꿈해몽.json';
import post25 from './25-용-키우는-꿈-로또번호-및-꿈해몽.json';
import post26 from './26-용-먹이-주는-꿈-로또번호-및-꿈해몽.json';
import post27 from './27-용-도망가는-꿈-로또번호-및-꿈해몽.json';
import post28 from './28-용-집에-들어오는-꿈-로또번호-및-꿈해몽.json';
import post29 from './29-용-품에-안는-꿈-로또번호-및-꿈해몽.json';
import post30 from './30-용-새끼-낳는-꿈-로또번호-및-꿈해몽.json';
import post31 from './31-용-많이-나오는-꿈-로또번호-및-꿈해몽.json';
import post32 from './32-돼지-잡는-꿈-로또번호-및-꿈해몽.json';
import post33 from './33-돼지에게-물리는-꿈-로또번호-및-꿈해몽.json';
import post34 from './34-멧돼지-꿈해몽-로또번호-및-해석.json';
import post35 from './35-호랑이-잡는-꿈-로또번호-및-꿈해몽.json';
import post36 from './36-호랑이에게-물리는-꿈-로또번호-및-꿈해몽.json';
import post37 from './37-사과-먹는-꿈-로또번호-및-꿈해몽.json';
import post38 from './38-사과-따는-꿈-로또번호-및-꿈해몽.json';
import post39 from './39-빨간-사과-꿈-로또번호-및-꿈해몽.json';
import post40 from './40-썩은-사과-꿈-로또번호-및-꿈해몽.json';
import post41 from './41-사과를-받는-꿈-로또번호-및-꿈해몽.json';
import post42 from './42-바나나-먹는-꿈-로또번호-및-꿈해몽.json';
import post43 from './43-바나나-사는-꿈-로또번호-및-꿈해몽.json';
import post44 from './44-바나나-받는-꿈-로또번호-및-꿈해몽.json';
import post45 from './45-썩은-바나나-꿈-로또번호-및-꿈해몽.json';
import post46 from './46-바나나-많이-나오는-꿈-로또번호-및-꿈해몽.json';
import post47 from './47-야구-경기하는-꿈-로또번호-및-꿈해몽.json';
import post48 from './48-홈런-치는-꿈-로또번호-및-꿈해몽.json';
import post49 from './49-야구공-잡는-꿈-로또번호-및-꿈해몽.json';
import post50 from './50-야구장에서-응원하는-꿈-로또번호-및-꿈해몽.json';
import post51 from './51-야구에서-지는-꿈-로또번호-및-꿈해몽.json';
import post52 from './52-축구-경기하는-꿈-로또번호-및-꿈해몽.json';
import post53 from './53-축구-골-넣는-꿈-로또번호-및-꿈해몽.json';
import post54 from './54-축구공-차는-꿈-로또번호-및-꿈해몽.json';
import post55 from './55-축구-경기에서-지는-꿈-로또번호-및-꿈해몽.json';
import post56 from './56-축구장에서-응원하는-꿈-로또번호-및-꿈해몽.json';
import post57 from './57-조규성-선수를-만나는-꿈-로또번호-및-꿈해몽.json';
import post58 from './58-조규성-선수와-사진-찍는-꿈-로또번호-및-꿈해몽.json';
import post59 from './59-조규성-선수가-골-넣는-꿈-로또번호-및-꿈해몽.json';
import post60 from './60-조규성-선수와-축구하는-꿈-로또번호-및-꿈해몽.json';
import post61 from './61-조규성-선수에게-사인-받는-꿈-로또번호-및-꿈해몽.json';
import post62 from './62-책-읽는-꿈-로또번호-및-꿈해몽.json';
import post63 from './63-책-사는-꿈-로또번호-및-꿈해몽.json';
import post64 from './64-책-선물-받는-꿈-로또번호-및-꿈해몽.json';
import post65 from './65-책이-찢어지는-꿈-로또번호-및-꿈해몽.json';
import post66 from './66-많은-책이-쌓여-있는-꿈-로또번호-및-꿈해몽.json';
import post67 from './67-초콜릿-먹는-꿈-로또번호-및-꿈해몽.json';
import post68 from './68-초콜릿-선물-받는-꿈-로또번호-및-꿈해몽.json';
import post69 from './69-초콜릿이-녹는-꿈-로또번호-및-꿈해몽.json';
import post70 from './70-에어컨-켜는-꿈-로또번호-및-꿈해몽.json';
import post71 from './71-에어컨-바람이-시원한-꿈-로또번호-및-꿈해몽.json';
import post72 from './72-에어컨-고장-나는-꿈-로또번호-및-꿈해몽.json';
import post73 from './73-장마비가-길게-내리는-꿈-로또번호-및-꿈해몽.json';
import post74 from './74-장마로-집-안에-물이-들어오는-꿈-로또번호-및-꿈해몽.json';
import post75 from './75-장마가-그치고-해가-나는-꿈-로또번호-및-꿈해몽.json';
import post76 from './76-폭죽이-크게-터지는-꿈-로또번호-및-꿈해몽.json';
import post77 from './77-밤하늘-폭죽을-바라보는-꿈-로또번호-및-꿈해몽.json';
import post78 from './78-폭죽이-꺼지는-꿈-로또번호-및-꿈해몽.json';
import post79 from './79-보름달-보는-꿈-로또번호-및-꿈해몽.json';
import post80 from './80-보름달-아래-걷는-꿈-로또번호-및-꿈해몽.json';
import post81 from './81-보름달이-구름에-가리는-꿈-로또번호-및-꿈해몽.json';
import post82 from './82-선글라스-쓰는-꿈-로또번호-및-꿈해몽.json';
import post83 from './83-선글라스-선물-받는-꿈-로또번호-및-꿈해몽.json';
import post84 from './84-선글라스가-깨지는-꿈-로또번호-및-꿈해몽.json';
import post85 from './85-이준석-국회의원을-만나는-꿈-로또번호-및-꿈해몽.json';
import post86 from './86-이준석-국회의원과-토론하는-꿈-로또번호-및-꿈해몽.json';
import post87 from './87-이준석-국회의원이-연설하는-꿈-로또번호-및-꿈해몽.json';
import post88 from './88-빅뱅-대성을-만나는-꿈-로또번호-및-꿈해몽.json';
import post89 from './89-빅뱅-대성의-노래를-듣는-꿈-로또번호-및-꿈해몽.json';
import post90 from './90-빅뱅-대성과-무대에-서는-꿈-로또번호-및-꿈해몽.json';
import post91 from './91-손목시계-차는-꿈-로또번호-및-꿈해몽.json';
import post92 from './92-손목시계가-멈추는-꿈-로또번호-및-꿈해몽.json';
import post93 from './93-손목시계를-선물-받는-꿈-로또번호-및-꿈해몽.json';
import post94 from './94-신용카드-사용하는-꿈-로또번호-및-꿈해몽.json';
import post95 from './95-신용카드를-잃어버리는-꿈-로또번호-및-꿈해몽.json';
import post96 from './96-신용카드-한도가-늘어나는-꿈-로또번호-및-꿈해몽.json';
import post97 from './97-생일과-기념일로-로또-번호-만드는-쉬운-방법.json';
import post98 from './98-최근-로또-당첨번호-분석해서-번호-고르는-방법.json';
import post99 from './99-홀짝-비율과-고저-비율로-로또-번호-조합하는-법.json';
import post100 from './100-랜덤으로-로또-번호-만드는-가장-간단한-방법.json';
import post101 from './101-꿈해몽과-직감으로-로또-번호-만드는-방법.json';
import lotto1233Posts from './lotto1233Posts';
import lottoImage102 from '../../../../assets/blog/lotto-1233/102-예상번호-총정리.svg';
import lottoImage103 from '../../../../assets/blog/lotto-1233/103-자동번호.svg';
import lottoImage104 from '../../../../assets/blog/lotto-1233/104-홀짝비율.svg';
import lottoImage105 from '../../../../assets/blog/lotto-1233/105-번호구간.svg';
import lottoImage106 from '../../../../assets/blog/lotto-1233/106-연속번호.svg';
import lottoImage107 from '../../../../assets/blog/lotto-1233/107-끝수중복.svg';
import lottoImage108 from '../../../../assets/blog/lotto-1233/108-번호합계.svg';
import lottoImage109 from '../../../../assets/blog/lotto-1233/109-이월수.svg';
import lottoImage110 from '../../../../assets/blog/lotto-1233/110-생일번호.svg';
import lottoImage111 from '../../../../assets/blog/lotto-1233/111-꿈숫자.svg';

const lotto1233ImageMap = {
  102: lottoImage102,
  103: lottoImage103,
  104: lottoImage104,
  105: lottoImage105,
  106: lottoImage106,
  107: lottoImage107,
  108: lottoImage108,
  109: lottoImage109,
  110: lottoImage110,
  111: lottoImage111
};

const hydratedLotto1233Posts = lotto1233Posts.map((post, index) => ({
  ...post,
  content: post.content.replace(`{{image-${index + 102}}}`, lotto1233ImageMap[index + 102])
}));

const dreamPostPages = [
  post01,
  post02,
  post03,
  post04,
  post05,
  post06,
  post07,
  post08,
  post09,
  post10,
  post11,
  post12,
  post13,
  post14,
  post15,
  post16,
  post17,
  post18,
  post19,
  post20,
  post21,
  post22,
  post23,
  post24,
  post25,
  post26,
  post27,
  post28,
  post29,
  post30,
  post31,
  post32,
  post33,
  post34,
  post35,
  post36,
  post37,
  post38,
  post39,
  post40,
  post41,
  post42,
  post43,
  post44,
  post45,
  post46,
  post47,
  post48,
  post49,
  post50,
  post51,
  post52,
  post53,
  post54,
  post55,
  post56,
  post57,
  post58,
  post59,
  post60,
  post61,
  post62,
  post63,
  post64,
  post65,
  post66,
  post67,
  post68,
  post69,
  post70,
  post71,
  post72,
  post73,
  post74,
  post75,
  post76,
  post77,
  post78,
  post79,
  post80,
  post81,
  post82,
  post83,
  post84,
  post85,
  post86,
  post87,
  post88,
  post89,
  post90,
  post91,
  post92,
  post93,
  post94,
  post95,
  post96,
  post97,
  post98,
  post99,
  post100,
  post101,
  ...hydratedLotto1233Posts
];

export default dreamPostPages;
